import React, { useState, useEffect } from "react";
import ro from "/src/content/ro.json";

const POLICY_VERSION = "2026-01";

export const getCookieConsent = () => {
  try {
    return JSON.parse(localStorage.getItem("cookieConsent"));
  } catch {
    return null;
  }
};

export const openCookieSettings = () => {
  window.dispatchEvent(new Event("openCookieSettings"));
};

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  // Starea fiecarei categorii de cookie
  const [prefs, setPrefs] = useState({
    necessary: true,
    functional: false,
    analytics: false,
  });

  // Analytics scripts must only load if getCookieConsent()?.analytics === true

  // Verifica daca utilizatorul a mai dat consimtamant
  useEffect(() => {
    const consent = getCookieConsent();
    if (consent) {
      setPrefs({
        necessary: true,
        functional: !!consent.functional,
        analytics: !!consent.analytics,
      });
    }
    setVisible(true);
  }, []);

  // Permite redeschiderea setarilor din alte zone ale aplicatiei
  useEffect(() => {
    const handler = () => {
      setVisible(true);
      setSettingsOpen(true);
    };
    window.addEventListener("openCookieSettings", handler);
    return () => window.removeEventListener("openCookieSettings", handler);
  }, []);

  const persistConsent = (nextPrefs) => {
    const payload = {
      necessary: true,
      functional: !!nextPrefs.functional,
      analytics: !!nextPrefs.analytics,
      updatedAt: new Date().toISOString(),
      policyVersion: POLICY_VERSION,
    };

    localStorage.setItem("cookieConsent", JSON.stringify(payload));
    setPrefs({
      necessary: true,
      functional: payload.functional,
      analytics: payload.analytics,
    });
    setVisible(false);
    setSettingsOpen(false);
    window.dispatchEvent(new Event("cookieConsentUpdated"));
  };

  // Salveaza preferintele in localStorage
  const saveConsent = (type) => {
    const payload =
      type === "accept"
        ? { necessary: true, functional: true, analytics: true }
        : { necessary: true, functional: false, analytics: false };

    persistConsent(payload);
  };

  // Salvare personalizata
  const saveCustom = () => {
    const nextPrefs = { ...prefs, necessary: true };
    persistConsent(nextPrefs);
  };

  if (!visible) return null;

  return (
    <>
      {/* Overlay pentru MODAL Setari */}
      {settingsOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-[9998]"
          onClick={() => setSettingsOpen(false)}
        ></div>
      )}

      {/* Banner principal */}
      <div
        className="fixed bottom-0 left-0 w-full z-[9999] p-5 shadow-xl transition-all"
        style={{
          backgroundColor: "var(--color-bg)",
          color: "var(--color-text)",
          borderTop: "3px solid var(--color-accent)",
        }}
      >
        {!settingsOpen ? (
          <div className="max-w-5xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <p className="text-sm md:text-base leading-relaxed">
              {ro.cookie.banner.textBeforeLink}{" "}
              <a
                href="/politica-cookie"
                className="text-orange-500 font-semibold underline"
              >
                {ro.cookie.banner.policyLabel}
              </a>
              {ro.cookie.banner.textAfterLink}
            </p>

            <div className="flex gap-3 flex-col md:flex-row">
              <button
                className="px-4 py-2 rounded-md font-semibold bg-gray-300 hover:bg-gray-400 transition text-black"
                onClick={() => saveConsent("reject")}
              >
                {ro.cookie.buttons.reject}
              </button>
              <button
                className="px-4 py-2 rounded-md font-semibold bg-orange-500 hover:bg-orange-400 text-white transition"
                onClick={() => saveConsent("accept")}
              >
                {ro.cookie.buttons.accept}
              </button>
              <button
                className="px-4 py-2 rounded-md font-semibold border text-orange-500 hover:bg-orange-100 transition"
                onClick={() => setSettingsOpen(true)}
              >
                {ro.cookie.buttons.settings}
              </button>
            </div>
          </div>
        ) : (
          /* MODAL Setari Cookies */
          <div
            className="fixed bottom-0 left-0 w-full z-[9999] p-6 shadow-2xl transition-all"
            style={{
              backgroundColor: "var(--color-bg)",
              color: "var(--color-text)",
              borderTop: "3px solid var(--color-accent)",
            }}
          >
            <h2 className="text-xl font-bold text-orange-500 mb-4">
              {ro.cookie.modal.title}
            </h2>

            {/* LISTA SETARI */}
            <div className="space-y-3">
              {/* Necesar */}
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold">{ro.cookie.modal.necessaryTitle}</p>
                  <p className="text-sm opacity-80">
                    {ro.cookie.modal.necessaryDesc}
                  </p>
                </div>
                <input type="checkbox" checked disabled />
              </div>

              {/* Functionale */}
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold">{ro.cookie.modal.functionalTitle}</p>
                  <p className="text-sm opacity-80">
                    {ro.cookie.modal.functionalDesc}
                  </p>
                </div>
                <input
                  type="checkbox"
                  checked={prefs.functional}
                  onChange={(e) =>
                    setPrefs({ ...prefs, functional: e.target.checked })
                  }
                />
              </div>

              {/* Analytics */}
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold">{ro.cookie.modal.analyticsTitle}</p>
                  <p className="text-sm opacity-80">
                    {ro.cookie.modal.analyticsDesc}
                  </p>
                </div>
                <input
                  type="checkbox"
                  checked={prefs.analytics}
                  onChange={(e) =>
                    setPrefs({ ...prefs, analytics: e.target.checked })
                  }
                />
              </div>
            </div>

            {/* BUTOANE */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                className="px-4 py-2 rounded-md border text-orange-500 hover:bg-orange-100 transition"
                onClick={() => setSettingsOpen(false)}
              >
                {ro.cookie.modal.back}
              </button>
              <button
                className="px-4 py-2 rounded-md bg-orange-500 text-white font-semibold hover:bg-orange-400 transition"
                onClick={saveCustom}
              >
                {ro.cookie.modal.save}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CookieConsent;
